import * as React from 'react';

function SvgClose(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M14.495 12l6.983-6.983a1.766 1.766 0 00-2.495-2.5L12 9.502 5.017 2.518a1.767 1.767 0 10-2.5 2.499L9.502 12l-6.983 6.983a1.767 1.767 0 102.499 2.5L12 14.498l6.983 6.983a1.767 1.767 0 002.5-2.499L14.494 12z" })));
}

export default SvgClose;
